import { PlusOutlined } from "@ant-design/icons"
import { Card, Empty, Flex, Typography, Upload, type UploadProps } from "antd"

interface ProjectAllFilesEmptyProps {
  uploadAllowed: boolean
  uploadProps: UploadProps
  maxFileSize: number
  allowedExtensions: string[]
}

export function ProjectAllFilesEmpty({
  uploadAllowed,
  uploadProps,
  allowedExtensions,
  maxFileSize
}: ProjectAllFilesEmptyProps) {
  return (
    <Flex vertical align="center" justify="center" gap={16} className="flex-1">
      {uploadAllowed && (
        <Upload {...uploadProps}>
          <Card hoverable>
            <Flex vertical align="center" gap={8}>
              <Flex align="center" gap={8} className="text-gray-400">
                <PlusOutlined className="text-xl" />
                <Typography.Text type="secondary">Upload Files</Typography.Text>
              </Flex>
              <Typography.Text type="secondary" className="text-xs text-center">
                Supported: {allowedExtensions.join(", ")}
                <br />
                Max size: {maxFileSize}MB
              </Typography.Text>
            </Flex>
          </Card>
        </Upload>
      )}
      <Empty
        description="No files found"
        image={Empty.PRESENTED_IMAGE_SIMPLE}
      />
    </Flex>
  )
}
